/*
 * @Author: duchongchong1
 * @Date: 2022-11-01 21:42:34
 * @LastEditors: weiyanna weiyanna@jd.com
 * @LastEditTime: 2026-06-17 13:12:41
 * @FilePath: /isp_International/src/layout/BaseLayout.tsx
 * @Description:
 */
import React, { useEffect, useCallback, useState } from 'react';
import { ConfigProvider, message } from 'antd';
import type { Locale } from 'antd/es/locale';
import { antDthemes, defaultTheme, loadGlobalVar } from './themes/themes';
import { resolveTheme } from './themes/resolveTheme';
import { toReport } from '@/dataPort/handler';
import FloatingRegisterButton from '@/components/FloatingRegisterButton';
import { isGuest } from '@/util/commonUtils';
import { useSelector } from 'react-redux';

import NewFooter from '@/components/NewFooter';
import { getLocal, LocalNameEnum } from '@/util/storage';
import Container from '@/components/Container';
import CustomerService from '@/components/CustomerService';
import { getRouteMetaInfo } from '@/router/routeMeta';
import NavBar from '@/components/NavBar';

const antdLocaleLoaders: Record<string, () => Promise<{ default: Locale }>> = {
  zh: () => import('antd/lib/locale/zh_CN'),
  zh_Hant: () => import('antd/lib/locale/zh_TW'),
  id: () => import('antd/lib/locale/id_ID'),
  de: () => import('antd/lib/locale/de_DE'),
  vi: () => import('antd/lib/locale/vi_VN'),
  en: () => import('antd/lib/locale/en_US'),
  hu: () => import('antd/lib/locale/hu_HU'),
  th: () => import('antd/lib/locale/th_TH'),
  ms: () => import('antd/lib/locale/ms_MY'),
  'pt-BR': () => import('antd/lib/locale/pt_BR'),
  ru: () => import('antd/lib/locale/ru_RU'),
};

const isAntdLocaleKey = (key: string | null | undefined): key is keyof typeof antdLocaleLoaders => {
  return Boolean(key && key in antdLocaleLoaders);
};

message.config({
  maxCount: 1,
});
const BaseLayout = (props: any) => {
  const { isAuth, children } = props;
  const currentPath = window.location.pathname;
  const meta = getRouteMetaInfo(currentPath);
  const isSimplePage = meta?.simplePage;
  const storedTheme = useSelector((state: any) => state?.User?.data?.[0]?.themeType);
  // 用户主题由鉴权后的 User 数据驱动；兼容旧数据或脏值时回退默认主题，避免固定 red 覆盖用户配置。
  const userTheme = resolveTheme(storedTheme, defaultTheme);

  const mulLangLocalTagRemark = getLocal(LocalNameEnum.mulLangLocalTagRemark);
  const [antdLocale, setAntdLocale] = useState<Locale | undefined>(undefined);

  useEffect(() => {
    loadGlobalVar(userTheme);
  }, [userTheme]);

  useEffect(() => {
    const localeKey = isAntdLocaleKey(mulLangLocalTagRemark) ? mulLangLocalTagRemark : 'en';
    let cancelled = false;

    void antdLocaleLoaders[localeKey]().then(module => {
      if (!cancelled) {
        setAntdLocale(module.default);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [mulLangLocalTagRemark]);

  const publicCapture = useCallback(e => {
    // 埋点
    toReport(e);
  }, []);

  return (
    <ConfigProvider
      locale={antdLocale}
      theme={{
        ...(antDthemes[userTheme] || {}),
      }}
    >
      <div className="ispWrapper" onClickCapture={publicCapture}>
        {/* 鉴权进行中（isAuth=null）也先挂载 NavBar，避免首页 Banner 先渲染、头部后插入导致布局跳动 */}
        {!isSimplePage && isAuth !== false && <NavBar {...props}></NavBar>}
        {isSimplePage ? children : <Container>{children}</Container>}
        {!isSimplePage && (
          <div
            style={{
              width: '100%',
              background: 'var(--footer-color-bg, #131A29)',
            }}
          >
            <NewFooter />
          </div>
        )}
        {!isSimplePage && <CustomerService />}
        {!isSimplePage && isGuest() && <FloatingRegisterButton />}
      </div>
    </ConfigProvider>
  );
};

export default BaseLayout;
